import { Router } from '@angular/router';
import { Component, OnInit, ViewEncapsulation, SimpleChanges, Renderer2, OnDestroy, Input } from '@angular/core';

import { Observable } from 'rxjs';

import { BaseVraagControlDirective } from '../base/base-vraag-control';
import { Vraag, Antwoord, Vraagtype } from '@models/claims';
import { IBaseVraagboomResultaat, VraagboomAntwoord, VraagboomEmptyResultaat } from '@models/vragenboom';
import { DataService } from '../../../services/data.service';
import { Proces } from '@components/public_api';
import { FormatHelper } from '@services/public_api';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-failure',
  templateUrl: './failure.component.html',
  styleUrls: ['./failure.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class FailureComponent extends BaseVraagControlDirective<VraagboomEmptyResultaat> implements OnInit, OnDestroy {
  kenmerken: string[] = [];
  vraagtitel: string;
  vraagregels: string[] = [];
  vraagtype = Vraagtype;
  resultaten$: Observable<VraagboomAntwoord<IBaseVraagboomResultaat>[]>;
  einddatum: string;

  constructor(
    private router: Router,
    private renderer: Renderer2,
    _dataService: DataService
  ) {
    super(_dataService);
  }

  ngOnInit() {
    if (this.vraag.vraagtype !== Vraagtype.OnlineNietMogelijk && this.vraag.vraagtype !== Vraagtype.AndersMelden) {
      this.renderer.addClass(document.body, 'ols-failure');
    }
    this.vraagtitel = this.vraag.titel;
    this.resultaten$ = this._dataService.resultaten;
    this.resultaten$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(res => {
        if (res !== undefined && res !== null) {
          this.verwerkResultaten(res);
        }
      });
  }

  verwerkResultaten(resultaten: VraagboomAntwoord<IBaseVraagboomResultaat>[]): void {
    this.kenmerken = [];
    this.vraagregels = [];
    this.einddatum = '';

    for (const resultaat of resultaten) {
      for (const antwoord of resultaat.antwoorden) {
        if (antwoord.kenmerken?.length > 0) {
          this.kenmerken = antwoord.kenmerken;
        }
        if (antwoord.einddatum?.length > 0) {
          this.einddatum = antwoord.einddatum;
        }
      }
    }
    if (this.vraag.vraagregels?.length > 0) {
      if (this.einddatum.length > 1) {
        this.vraag.vraagregels.forEach((r: string) => {
          this.vraagregels.push(r.replace('{einddatum}', this.einddatum));
        });
      } else {
        this.vraagregels = this.vraag.vraagregels;
      }
    }
    if (this.vraag?.titel?.length > 0) {
      this.vraagtitel = this.vraag.titel;

      if (this.kenmerken?.length > 0) {
        if (this.vraag.titel.substring(this.vraag.titel.length - 1) === '.') {
          this.vraagtitel = this.vraag.titel.substring(0, this.vraag.titel.length - 1);
        }
        this.vraagtitel = this.vraagtitel + ': ' + FormatHelper.stringMetSeparator(this.kenmerken, ' | ') + '.';
      }
    }
  }

  ngOnDestroy() {
    if (this.vraag.vraagtype !== Vraagtype.OnlineNietMogelijk && this.vraag.vraagtype !== Vraagtype.AndersMelden) {
      this.renderer.removeClass(document.body, 'ols-failure');
    }
    super.ngOnDestroy();
  }

  initialize(changes: SimpleChanges): void { }

  validate(vraag: Vraag, antwoorden: Antwoord[], resultaat: VraagboomEmptyResultaat): boolean {
    return true;
  }

  redirect(): void {
    if (this.vraag && this.vraag.button_link) {
      if (this.vraag.button_link.startsWith('/')) {
        window.location.href = this.vraag.button_link;
      } else {
        this.router.navigate(['/externalRedirect', { externalUrl: this.vraag.button_link }]);
      }
    }
  }

  geefPazaProces(): string {
    return this._dataService.getMeetidPazaProces();
  }

  tekstDeel1(regels: string[]): string {
    if (regels?.length > 0 && this.kenmerken.length > 1) {
      return regels[0].replace('{merk}', this.kenmerken[0]).replace('{kenteken}', this.kenmerken[1]);
    }
    if (this._dataService.getProces() === Proces.SchademeldenZakelijk) {
      return regels[0];
    }
    return '';
  }

  tekstDeel2(regels: string[]): string {
    return regels?.length > 1 ? regels[1] : '';
  }
}
